import React from "react"

import Image from "../Image/Image"
import RichText from "../RichText"
import LinkWrapper from "../LinkWrapper"

import { MediaModel } from "../../models/components"

interface CaptionImageProps extends MediaModel {
  cssClass?: string
  pageContext: any
}

const defaultProps = {}

export const CaptionImage: React.FC<CaptionImageProps> = props => {
  // console.log("CaptionImage: ", props)
  if (!props.image) return null

  if (props.caption)
    return (
      <figure className="embed" data-imagesrc={props.image.url}>
        <LinkWrapper anchor={props.anchor} pageContext={props.pageContext}>
          <Image {...props} image={props.image} />
        </LinkWrapper>
        {typeof props.caption === "string" && (
          <figcaption>{props.caption}</figcaption>
        )}
        {typeof props.caption === "object" && (
          <RichText
            content={props.caption}
            figcaption
            pageContext={props.pageContext}
          />
        )}
      </figure>
    )

  return <Image {...props} image={props.image} />
}

CaptionImage.defaultProps = defaultProps

export default CaptionImage
